// extracted by mini-css-extract-plugin
export var numpadContainer = "_rv-1";
export var phoneButton = "_rv-0";